import { useTranslation } from "react-i18next";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import styles from "./fullScreenSlider.module.scss";

export const FullScreenSlider = ({ startIndex, setStartIndex, images, onClose}) => {
  const { t } = useTranslation();

  const formattedImages = images?.map((base64Image) => ({
    original: base64Image,
    thumbnail: base64Image,
  }));

  return (
    <div className={styles.fullScreenSlider}>
      <ImageGallery
        lazyLoad={true}
        items={formattedImages}
        startIndex={startIndex}
        showPlayButton={false}
        showFullscreenButton={true}
        onSlide={(index) => setStartIndex(index)}
      />
      <button
        className={styles.fullScreenSlider_closeBtn}
        onClick={onClose}
        type="button"
        aria-label={t("btn_close")}
      >
        {t("btn_close")}
      </button>
    </div>
  );
};
